import React, { useEffect } from 'react';
import Checkmark from '@uber/base-icons/checkmark';
import X from '@uber/base-icons/x';
import { useStyletron } from 'baseui';
import { Button, KIND, SIZE } from 'baseui/button';
import { LabelSmall } from 'baseui/typography';
import useShortcut from '../../../image/labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError } from '../../../image/labelling/providers/utils/shortcut';
import { actionButtonOverrides as buttonOverrides, StickyActionContainer as Container } from '../styled-component-overrides';
type Props = {
  onAccept: () => void;
  onReject: () => void;
};
export const ActionPanel = ({
  onAccept,
  onReject
}: Props) => {
  const [_, theme] = useStyletron();
  const {
    registerHotKeys
  } = useShortcut();
  useEffect(() => {
    const {
      removeHotKeys,
      errors
    } = registerHotKeys([{
      keys: ['Shift', 'r'],
      onAction: onReject
    }, {
      keys: ['Shift', 'a'],
      onAction: onAccept
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [registerHotKeys, onReject, onAccept]);
  return <Container>
      <Button size={SIZE.compact} kind={KIND.tertiary} startEnhancer={<X />} onClick={onReject} overrides={buttonOverrides}>
        <LabelSmall>Reject Label</LabelSmall>
      </Button>
      <Button size={SIZE.compact} kind={KIND.primary} startEnhancer={<Checkmark />} onClick={onAccept} overrides={buttonOverrides}>
        <LabelSmall color={theme.colors.contentInversePrimary}>Approve Label</LabelSmall>
      </Button>
    </Container>;
};